import { GridCellProps } from "@progress/kendo-react-grid";
import ProductInfo from "../../commons/components/ProductInfo";

export default function InformationsCell(props: GridCellProps) {
    return <td><ProductInfo item={props.dataItem}/></td>;
}